import React from "react";
import {useAppIconStyle} from '../styles/AppIconStyle';
import {Typography} from "@material-ui/core";
import clsx from "clsx";
import Strings from '../lang/Strings';
import {Link} from "react-router-dom";
import Routes from "../constants/Routes";
import {useSelector, RootStateOrAny} from "react-redux";
import {LoginState} from '../enums/AuthState';
import {Constants} from "../constants/Constants";

const AppIcon = React.forwardRef(function AppIcon(props: any, ref: any) {

    const classes = useAppIconStyle();
    const logInState: LoginState = useSelector((state: RootStateOrAny) => state.appReducer[Constants.LOGIN_STATE]);

    return (
        <Link ref={ref} to={logInState === LoginState.STARTED ? "#" : Routes.DEFAULT} style={{
            textDecoration: 'none'
        }} {...props}>
            <div style={{display: 'flex', alignItems: 'center'}}>
                <img src={require('../images/bitcoin_for_all.png')}
                     className={classes.appIcon} alt={"Bitcoin For All"}/>
                <Typography className={clsx(classes.appName)}
                            dangerouslySetInnerHTML={{__html: Strings.STYLED_APP_NAME}}/>
            </div>
        </Link>
    );
});
export default AppIcon;